import React from 'react'
import '../styles/loader.css'

const Loader = () => {

  return (
    <div className="loader-container">
      <img className="loader-image" src='/images/loader.png' alt="Loading" />
    </div>
  )
}

export default Loader